import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SetComponentsService {
  constructor() {}

  BANNER: BehaviorSubject<any> = new BehaviorSubject(null);
  CHARTS: BehaviorSubject<any> = new BehaviorSubject(null);
  CTA: BehaviorSubject<any> = new BehaviorSubject(null);
  customerCare: BehaviorSubject<any> = new BehaviorSubject(null);
  EMBED: BehaviorSubject<any> = new BehaviorSubject(null);
  FEEDBACK: BehaviorSubject<any> = new BehaviorSubject(null);
  GRID: BehaviorSubject<any> = new BehaviorSubject(null);
  hasCustomerCareFormChanges: BehaviorSubject<any> = new BehaviorSubject<boolean>(false);
  HOURS: BehaviorSubject<any> = new BehaviorSubject(null);
  IMAGE: BehaviorSubject<any> = new BehaviorSubject(null);
  MAPS: BehaviorSubject<any> = new BehaviorSubject(null);
  newRow: BehaviorSubject<any> = new BehaviorSubject([]);
  placement: BehaviorSubject<any> = new BehaviorSubject([]);
  SHOWCASE: BehaviorSubject<any> = new BehaviorSubject(null);
  template: BehaviorSubject<any> = new BehaviorSubject([]);
  TEXT: BehaviorSubject<any> = new BehaviorSubject(null);
  TEXTstring: BehaviorSubject<any> = new BehaviorSubject([]);
  TOPIC: BehaviorSubject<any> = new BehaviorSubject(null);
  typeOf: BehaviorSubject<any> = new BehaviorSubject([]);
  updateComponent: BehaviorSubject<any> = new BehaviorSubject([]);

  setPlacement(row, comp) {
    const result = { row: row, comp: comp };
    this.placement.next(result);
  }
  setType(typeOf) {
    const result = { typeOf: typeOf };
    this.typeOf.next(result);
  }
  setTemplate(template) {
    const result = { typeOf: '', components: template };
    this.template.next(result);
  }
  getPlacement() {
    return this.placement.asObservable();
  }
  getType() {
    return this.typeOf.asObservable();
  }
  getTemplate() {
    return this.template.asObservable();
  }

  // creating a new row.
  setRow(data, typeOf, template, row, comp) {
    this.setType(typeOf);
    this.setTemplate(template);
    this.setPlacement(row, null);
    const result = { data: data, typeOf: typeOf, template: template, row: row, comp: comp };

    this.newRow.next(result);
  }
  getRow() {
    return this.newRow.asObservable();
  }

  // changing components on the fly.
  setComponent(data, typeOf, template, row, comp) {
    this.setType(typeOf);
    this.setTemplate(template);
    this.setPlacement(row, null);
    const result = { data: data, typeOf: typeOf, template: template, row: row, comp: comp };
    this.updateComponent.next(result);
  }
  getComponent() {
    return this.updateComponent.asObservable();
  }

  getCustomerCare() {
    return this.customerCare.asObservable();
  }

  setCustomerCare(component) {
    this.customerCare.next(component);
  }

  getHasCustomerCareFormChangesValue(): boolean {
    return this.hasCustomerCareFormChanges.getValue();
  }

  setHasCustomerCareFormChanges(value): void {
    this.hasCustomerCareFormChanges.next(value);
  }

  setCTA(data, typeOf, template, row, comp) {
    this.setType(typeOf);
    this.setTemplate(template);
    this.setPlacement(row, comp);
    this.CTA.next(data);
  }
  getCTA() {
    return this.CTA.asObservable();
  }

  setIMAGE(data, typeOf, template, row, comp) {
    this.setType(typeOf);
    this.setTemplate(template);
    this.setPlacement(row, comp);
    this.IMAGE.next(data);
  }
  getIMAGE() {
    return this.IMAGE.asObservable();
  }

  setTEXT(data, typeOf, template, row, comp) {
    this.setType(typeOf);
    this.setTemplate(template);
    this.setPlacement(row, comp);
    this.TEXT.next(data);
  }
  getTEXT() {
    return this.TEXT.asObservable();
  }
  setTextString(index, data) {
    this.TEXTstring.next((this.TEXTstring[index] = data));
  }
  getTextString() {
    return this.TEXTstring.asObservable();
  }

  setTOPIC(data, typeOf, template, row, comp) {
    this.setType(typeOf);
    this.setTemplate(template);
    this.setPlacement(row, comp);
    this.TOPIC.next(data);
  }
  getTOPIC() {
    return this.TOPIC.asObservable();
  }

  setFEEDBACK(data, typeOf, template, row, comp) {
    this.setType(typeOf);
    this.setTemplate(template);
    this.setPlacement(row, comp);
    this.FEEDBACK.next(data);
  }
  getFEEDBACK() {
    return this.FEEDBACK.asObservable();
  }

  setSHOWCASE(data, typeOf, template, row, comp) {
    this.setType(typeOf);
    this.setTemplate(template);
    this.setPlacement(row, comp);
    this.SHOWCASE.next(data);
  }
  getSHOWCASE() {
    return this.SHOWCASE.asObservable();
  }

  setBANNER(data, typeOf, template, row, comp) {
    this.setType(typeOf);
    this.setTemplate(template);
    this.setPlacement(row, comp);
    this.BANNER.next(data);
  }
  getBANNER() {
    return this.BANNER.asObservable();
  }

  setHOURS(data, typeOf, template, row, comp) {
    this.setType(typeOf);
    this.setTemplate(template);
    this.setPlacement(row, comp);
    this.HOURS.next(data);
  }
  getHOURS() {
    return this.HOURS.asObservable();
  }

  setEMBED(data, typeOf, template, row, comp) {
    this.setType(typeOf);
    this.setTemplate(template);
    this.setPlacement(row, comp);
    this.EMBED.next(data);
  }
  getEMBED() {
    return this.EMBED.asObservable();
  }

  setMAPS(data, typeOf, template, row, comp) {
    this.setType(typeOf);
    this.setTemplate(template);
    this.setPlacement(row, comp);
    this.MAPS.next(data);
  }

  getMAPS() {
    return this.MAPS.asObservable();
  }

  setCHARTS(data, typeOf, template, row, comp) {
    this.setType(typeOf);
    this.setTemplate(template);
    this.setPlacement(row, comp);
    this.CHARTS.next(data);
  }
  getCHARTS() {
    return this.CHARTS.asObservable();
  }

  setGRID(data, typeOf, template, row, comp) {
    this.setType(typeOf);
    this.setTemplate(template);
    this.setPlacement(row, comp);
    this.GRID.next(data);
  }
  getGRID() {
    return this.GRID.asObservable();
  }
}
